import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import { webViewTapped } from '../../../actions/tapEvents'
import * as RegionalContentLookup from '../../methods/RegionalContentLookUp'

function PacemakerPrecautions(props) {
  const { t, regionalContentLookup } = props

  function getUrl() {
    return regionalContentLookup('pacemakerPrecautionLinks')
  }

  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="pacemaker-precautions-title">{t('pacemakerPrecautionsTitle')}</Text>
      </View>
      <View>
        <Text style={[textStyles.bodyContentText]} testID="pacemaker-precautions-paragraph1">{t('pacemakerPrecautionsParagraph1')}</Text>
        <Text style={[textStyles.bodyContentText]} testID="pacemaker-precautions-paragraph2">{t('pacemakerPrecautionsParagraph2')}</Text>
        <TouchableOpacity
          onPress={() => { webViewTapped(getUrl(), 'pacemakerLearnMoreLink') }}
          accessibilityLabel="Pacemaker Precautions Link"
          testID="pacemaker-precautions-learn-more-link"
        >
          <View style={styles.button}>
            <Text style={[styles.hyperlink, styles.textMargin, styles.linkText]}>
              {t('pacemakerPrecuationsLearnMoreLink')}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

PacemakerPrecautions.propTypes = {
  regionalContentLookup: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const actionCreators = {
  regionalContentLookup: RegionalContentLookup.regionalContentLookup,
}

export default withTranslation('faq')(connect(null, actionCreators)(PacemakerPrecautions))
